var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyAltWhite35X35 = function SvgCopyAltWhite35X35(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54896",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4355",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "copy-alt-3",
    d: "M20.85 24.198h-6.7a2.512 2.512 0 0 1-2.512-2.512v-8.372a.837.837 0 0 0-1.672 0v8.372a4.186 4.186 0 0 0 4.186 4.186h6.7a.837.837 0 1 0 0-1.674Zm4.186-9.26a1.1 1.1 0 0 0-.05-.226v-.075a.9.9 0 0 0-.159-.234l-5.024-5.024a.9.9 0 0 0-.234-.159h-.075l-.268-.092h-3.4a2.512 2.512 0 0 0-2.511 2.512v8.372a2.512 2.512 0 0 0 2.511 2.516h6.7a2.512 2.512 0 0 0 2.512-2.512v-5.078Zm-5.024-2.955 2.168 2.168h-1.33a.837.837 0 0 1-.837-.837Zm3.354 8.029a.837.837 0 0 1-.837.837h-6.703a.837.837 0 0 1-.837-.837V11.64a.837.837 0 0 1 .837-.837h2.512v2.511a2.512 2.512 0 0 0 2.512 2.514h2.516Z",
    fill: "#eff0f6"
  })));
};
export default SvgCopyAltWhite35X35;